import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    ModalTypes,
    quizProgressTypes,
    pagerActionTypes,
    compStatusTypes,
    answerStatusTypes,
} from '../Constants';
import {
    /* action dispatch */
    updateQuizData,
    /* action types */
    UPDATE_QUIZ_DATA,
    UPDATE_ANSWER_DATA,
    UPDATE_ANSWER_SINGLE_DATA,
    CLEAR_ANSWER_DATA,
    CLEAR_ANSWER_DATA_BY_INDEX,
} from '../actions';
import Button from './CommonSet/Button';
import Title from './QuizSet/Title';
import Body from './QuizSet/Body';
import Progress from './CommonSet/Progress';
import Pager from './CommonSet/Pager';
import Popup from './QuizSet/Popup';
import Report from './QuizSet/Report';
import Utils from '../sources/Utils';
import Styles from './QuizSet/BaseComponent.cssmodule.less';

class Quiz extends Component {
    constructor(props) {
        super(props);
        this.state = {
            index: 0,
            isLastcontents: false,
            progress: quizProgressTypes.SOLVING,
            answerStatus: answerStatusTypes.NONE,
            prevStatus: compStatusTypes.HIDDEN,
            nextStatus: compStatusTypes.DISABLED,
            btnCompleteStatus: compStatusTypes.DISABLED,
            reportStatus: compStatusTypes.HIDDEN,
            progressStatus: compStatusTypes.ENABLED,
            indicatorStatus: compStatusTypes.ENABLED,
        };
        const { contents = [] } = props.data;

        if (Array.isArray(contents)) {
            this.contents = contents;
        } else if ('quiz' in contents) {
            this.contents = contents.quiz;
            this.outroPopupData = contents.outro;
            this.outroTitle = contents.outroTitle;
            this.externalName = contents.externalName;
            this.externalLink = contents.externalLink;
            this.outroPopup = new entrylms.Modal();
            this.outroPopup.on('hide', (type) => {
                entrylms.emit(
                    'NextStudy',
                    {
                        category: 'quiz',
                    },
                    () => {
                        this.clearQuizSetting();
                    }
                );
            });
        }

        this.createdItems = [];

        if (props.quizData) {
            this.state['reportStatus'] = compStatusTypes.ENABLED;
            this.state['progressStatus'] = compStatusTypes.HIDDEN;
            this.state['indicatorStatus'] = compStatusTypes.HIDDEN;
            this.createdItems = props.quizData;
        }

        if (props.saveAnswerData) {
            this.props.actions.updateQuizData(
                UPDATE_ANSWER_DATA,
                props.saveAnswerData
            );
        }

        this.handlePagerClick = this.handlePagerClick.bind(this);
        this.handleSelectAnswer = this.handleSelectAnswer.bind(this);
        this.handleClickPopup = this.handleClickPopup.bind(this);
        this.handleCompleteButtonClick = this.handleCompleteButtonClick.bind(
            this
        );
        this.handleClickRetry = this.handleClickRetry.bind(this);
        this.handleClickConfirm = this.handleClickConfirm.bind(this);
        this.interceptIndex;
    }

    /* Lifecycle Events */
    componentWillMount() {
        if (!Entry.type) {
            Entry.init(Entry.createElement('div'), {
                fonts: EntryStatic.fonts,
                libDir: '/lib',
                type: 'invisible',
                soundeditable: false,
                pictureeditable: false,
                hasvariablemanager: false,
            });
        }

        this.loadEntryData(this.props.data);
    }

    componentWillReceiveProps(nextProps) {
        let data, answerData;
        if (this.props.data._id !== nextProps.data._id) {
            this.clearQuizSetting(nextProps);
            data = nextProps.data;
            this.loadEntryData(data);
        }
        if (nextProps.answerData) {
            answerData = nextProps.answerData;
        }
        this.pagerSetting(this.interceptIndex, undefined, data, answerData);
        this.interceptIndex = undefined;
    }

    componentWillUnmount() {
        this.clearQuizSetting();
    }

    /* Lifecycle Events */

    /* Events Handler */

    handleClickPopup(type) {
        let index = this.state.index;
        if (type === answerStatusTypes.CORRECT) {
            index += 1;
        } else if (type === answerStatusTypes.INCORRECT) {
            this.props.actions.updateQuizData(CLEAR_ANSWER_DATA_BY_INDEX, {
                index,
            });
        }

        if (index < this.contents.length) {
            this.pagerSetting(index, answerStatusTypes.NONE);
        } else {
            this.completeStydyAction(() => {
                this.setState({
                    answerStatus: answerStatusTypes.NONE,
                    reportStatus: compStatusTypes.ENABLED,
                    indicatorStatus: compStatusTypes.HIDDEN,
                });
            });
        }
    }

    handleClickRetry() {
        this.clearQuizSetting();
    }

    handleClickConfirm() {
        if (this.outroPopupData) {
            this.outroPopup.modalData = this.outroPopupData.map((item) => {
                item.type = ModalTypes.OUTRO;
                item.title = this.outroTitle || '';
                console.log(this, item);
                if (this.externalName) {
                    item.external = {
                        name: this.externalName,
                        url: this.externalLink,
                    };
                }
                return item;
            });
            this.outroPopup.show();
        } else {
            entrylms.emit(
                'NextStudy',
                {
                    category: 'quiz',
                },
                () => {
                    this.clearQuizSetting();
                }
            );
        }
    }

    handleCompleteButtonClick() {
        if (!this.isAllSelectAnswer()) {
            return;
        }

        if (this.props.injectOption.isCheckAnwser) {
            this.correctAnswer();
        } else {
            this.completeStydyAction(() => {
                this.setState({
                    reportStatus: compStatusTypes.ENABLED,
                    indicatorStatus: compStatusTypes.HIDDEN,
                });
            });
        }
    }

    handleSelectAnswer(data) {
        if (this.props.data.isMultiChoice) {
            // TODO: 다중 체크 생길때 확인.
            this.props.actions.updateQuizData(UPDATE_ANSWER_DATA, data);
        } else {
            this.props.actions.updateQuizData(UPDATE_ANSWER_SINGLE_DATA, data);
        }
    }

    handlePagerClick(type) {
        let index = this.state.index;

        if (type === pagerActionTypes.PREV) {
            if (this.state.index > 0) {
                index = this.state.index - 1;
            }
        } else if (type === pagerActionTypes.NEXT) {
            if (this.contents && this.state.index < this.contents.length - 1) {
                if (this.props.injectOption.isCheckAnwser) {
                    this.correctAnswer();
                } else {
                    index = this.state.index + 1;
                }
            }
        }
        this.pagerSetting(index);
    }

    isAllSelectAnswer() {
        const { answerData = {} } = this.props;
        let isAllSelect = true;

        const quizLength = Object.keys(this.createdItems).length;
        const answerLength = Object.keys(answerData).length;

        if (quizLength !== answerLength) {
            return false;
        }

        for (let i in answerData) {
            const answer = answerData[i];
            let isAnswerSelect = false;
            for (let j in answer) {
                const isCheck = answer[j];
                if (isCheck) {
                    isAnswerSelect = true;
                }
            }

            if (!isAnswerSelect) {
                isAllSelect = false;
            }
        }

        return isAllSelect;
    }

    completeStydyAction(callback) {
        let type = 'ExitStudy';

        entrylms.emit(
            type,
            {
                category: 'quiz',
                value: Object.assign({}, this.correctAnswerData(), {
                    quizData: this.createdItems,
                    answerData: this.props.answerData,
                }),
            },
            callback
        );
    }

    /* Events Handler */

    /* User Function*/

    loadEntryData(data) {
        if (data) {
            const { basicProject } = data;

            if (basicProject) {
                Entry.clearProject();
                Entry.loadProject(basicProject);
            }
        }
    }

    clearQuizSetting(props = {}) {
        this.createdItems = [];
        this.interceptIndex = 0;

        const clearStatus = {
            reportStatus: compStatusTypes.HIDDEN,
            progressStatus: compStatusTypes.ENABLED,
            indicatorStatus: compStatusTypes.ENABLED,
        };

        if (props.quizData) {
            clearStatus['reportStatus'] = compStatusTypes.ENABLED;
            clearStatus['progressStatus'] = compStatusTypes.HIDDEN;
            clearStatus['indicatorStatus'] = compStatusTypes.HIDDEN;
            this.createdItems = props.quizData;
        }

        if (props.saveAnswerData) {
            this.props.actions.updateQuizData(
                UPDATE_ANSWER_DATA,
                props.saveAnswerData
            );
        } else {
            this.props.actions.updateQuizData(CLEAR_ANSWER_DATA);
        }

        this.setState(clearStatus);
    }

    pagerSetting(
        index = this.state.index,
        answerStatus,
        data = this.props.data,
        answerData = this.props.answerData
    ) {
        if (this.contents) {
            let isLastcontents = false;
            let prevStatus = compStatusTypes.DISABLED;
            let nextStatus = compStatusTypes.DISABLED;
            let btnCompleteStatus = compStatusTypes.HIDDEN;
            let injectOption = data.injectOption || {};

            if (index <= 0) {
                prevStatus = compStatusTypes.HIDDEN;
            } else if (
                injectOption.isCheckAnwser ||
                (!injectOption.isCheckAnwser && !injectOption.isMovePossible)
            ) {
                prevStatus = compStatusTypes.DISABLED;
            } else if (injectOption.isMovePossible) {
                prevStatus = compStatusTypes.ENABLED;
            }

            if (index >= this.contents.length - 1) {
                nextStatus = compStatusTypes.HIDDEN;
                btnCompleteStatus = compStatusTypes.ENABLED;
                isLastcontents = true;
            } else if (index in answerData) {
                const answer = answerData[index];
                let isAnswerCheck = false;
                for (let i in answer) {
                    if (answer[i]) {
                        isAnswerCheck = true;
                    }
                }

                nextStatus = isAnswerCheck
                    ? compStatusTypes.ENABLED
                    : compStatusTypes.DISABLED;
            }

            const stateData = {
                index,
                prevStatus,
                nextStatus,
                isLastcontents,
                btnCompleteStatus,
            };

            if (answerStatus) {
                stateData.answerStatus = answerStatus;
            }
            this.setState(stateData);
        }
    }

    correctAnswer() {
        const answerData = this.props.answerData[this.state.index];
        const createdItems = this.createdItems[this.state.index];
        let isCorrect = true;

        Object.keys(createdItems).forEach((key) => {
            if (
                (createdItems[key].isCorrect && !answerData[key]) ||
                (answerData[key] && !createdItems[key].isCorrect)
            ) {
                isCorrect = false;
            }
        });

        const type = isCorrect
            ? answerStatusTypes.CORRECT
            : answerStatusTypes.INCORRECT;

        this.setState({
            answerStatus: type,
        });
    }

    correctAnswerData() {
        let correctCount = 0;
        let questionsCount = 0;

        Object.keys(this.props.answerData).forEach((key) => {
            const answerData = this.props.answerData[key];
            const createdItems = this.createdItems[key];
            let isCorrect = true;
            Object.keys(createdItems).forEach((innerKey) => {
                if (
                    (createdItems[innerKey].isCorrect &&
                        !answerData[innerKey]) ||
                    (answerData[innerKey] && !createdItems[innerKey].isCorrect)
                ) {
                    isCorrect = false;
                }
            });

            questionsCount += 1;
            if (isCorrect) {
                correctCount += 1;
            }
        });

        return {
            questionsCount,
            correctCount,
        };
    }

    createCompleteStyle() {
        const completeStyle = {
            display: 'none',
        };

        if (this.state.isLastcontents) {
            completeStyle.display = 'block';
        }

        return completeStyle;
    }

    createItem(pickData) {
        let items = [];

        if (this.props.quizData) {
            this.createdItems = this.props.quizData;
        }

        if (this.state.index in this.createdItems) {
            items = this.createdItems[this.state.index];
        } else {
            items = pickData.items.map((text, index) => ({
                text,
                isCorrect: pickData.correctAnswers.indexOf(index) > -1,
            }));

            if (this.props.injectOption.isRandomQuestion) {
                items = Utils.shuffleArray(items);
            }

            this.createdItems = Object.assign({}, this.createdItems, {
                [this.state.index]: items,
            });
        }

        // this.props.actions.updateQuizData(UPDATE_QUIZ_DATA, this.createdItems);

        return items;
    }

    /* User Function*/

    render() {
        if (!this.contents) {
            return null;
        }
        const pickData = this.contents[this.state.index];
        let answerData = {};
        if (this.props.answerData) {
            answerData = this.props.answerData[this.state.index];
        }
        const questionData = this.createItem(pickData);
        return (
            <div className={Styles.quizComponent}>
                <div className={Styles.componentWrapper}>
                    <Progress
                        nowValue={this.state.index}
                        maxValue={this.contents.length}
                        progressStatus={this.state.progressStatus}
                        indicatorStatus={this.state.indicatorStatus}
                    />
                    <Title text={this.props.data.name} />
                    <Pager
                        onPagerClick={this.handlePagerClick}
                        prevStatus={this.state.prevStatus}
                        nextStatus={this.state.nextStatus}
                    />
                    <div className={Styles.quizMain}>
                        <Body
                            index={this.state.index}
                            data={pickData}
                            answerData={answerData}
                            questionData={questionData}
                            isRandom={this.props.injectOption.isRandomQuestion}
                            isMultiChoice={this.props.data.isMultiChoice}
                            onSelectAnswer={this.handleSelectAnswer}
                        />
                        <div
                            className={Styles.complete}
                            style={this.createCompleteStyle()}
                        >
                            <Button
                                text={Utils.getLang('Buttons.done')}
                                status={this.state.btnCompleteStatus}
                                onClick={this.handleCompleteButtonClick}
                            />
                        </div>
                    </div>
                    <Report
                        text={
                            this.props.data.name || this.props.data.parentTitle
                        }
                        answerData={this.props.answerData}
                        createdItems={this.createdItems}
                        reportStatus={this.state.reportStatus}
                        isCheckAnwser={this.props.injectOption.isCheckAnwser}
                        isHomework={this.props.data.isHomework}
                        isHomeworkLapse={this.props.data.isHomeworkLapse}
                        questionsData={this.contents}
                        onClickRetry={this.handleClickRetry}
                        onClickConfirm={this.handleClickConfirm}
                    />
                </div>
                <Popup
                    answerStatus={this.state.answerStatus}
                    onClickPopup={this.handleClickPopup}
                />
            </div>
        );
    }
}

Quiz.displayName = 'Quiz';
Quiz.propTypes = {
    actions: PropTypes.object,
    data: PropTypes.object.isRequired,
};
Quiz.defaultProps = {
    data: {
        title: '',
        homeworkDueDate: 0,
        isHomework: false,
        isHomeworkLapse: false,
        isLastStudy: false,
        contents: [],
    },
};

function mapStateToProps(state) {
    const props = {
        answerData: state.quiz.answerData,
        createdcontents: state.quiz.createdcontents,
    };
    return props;
}

// TODO Quiz 데이터 dispatch 구현
function mapDispatchToProps(dispatch) {
    const actions = { updateQuizData };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Quiz);



// WEBPACK FOOTER //
// ./components/Quiz.js